import { computed, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import {
    selectCurrentServiceId,
    selectCurrentServiceSettings,
    selectFolder,
    selectFolderId,
    selectIsFolderTerminated,
    selectServices,
} from '../../../store/person/person.selectors';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../shared/shared.global-service';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import {
    SERVICE_SETTINGS_MEDICATION_TYPE_DEFAULT,
    SERVICE_SETTINGS_MEDICATION_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-medication.type';
import { FolderMedicationGridItemObject } from '@it2go/types';

@Injectable()
export class FolderMedicationsPageStore extends ComponentStoreV2Factory {

    folderId = toSignal(globalStore!.select(selectFolderId));
    folder = toSignal(globalStore!.select(selectFolder));
    isTerminated = toSignal(globalStore!.select(selectIsFolderTerminated));
    serviceId = toSignal(globalStore!.select(selectCurrentServiceId));
    public service = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(this.serviceId)());

    public gridData = computed(() => {
        let data = this.data.getFolderMedications();
        if (!data) return null;

        const now = new Date();
        const items = data.items?.map((it: FolderMedicationGridItemObject) => {
            const from = new Date(it.from);
            const to = it.to ? new Date(it.to) : null;
            const isValid = from < now && (!to || to > now);

            return {
                ...it,
                activeOutOfDate: it.active && !isValid,
            };
        });

        return {
            ...data,
            items,
        };
    });
    public items = computed(() => this.data.getFolderMedications()?.['items'] || []);

    medicationSharingIds = toSignal(globalStore!.select(selectServices).pipe(
        map((services) =>
            getSharingFolderIds(this.serviceId(), services, this.folder()?.relatedFolders, SERVICE_SETTINGS_MEDICATION_TYPE_KEY),
        ),
    ));
    medicationSettings = toSignal(globalStore!.select(
        selectCurrentServiceSettings(SERVICE_SETTINGS_MEDICATION_TYPE_KEY, SERVICE_SETTINGS_MEDICATION_TYPE_DEFAULT),
    ));
}
